'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import I18n from 'I18n';
import { Component } from 'react';
import Raven from 'raven-js';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
export default class ErrorBoundary extends Component {
  componentDidCatch(error) {
    const {
      registerError
    } = this.props;
    registerError();
    Raven.captureMessage(error);
  }

  render() {
    const {
      hasError,
      resetFormState
    } = this.props;

    if (hasError) {
      return /*#__PURE__*/_jsxs(UIAlert, {
        type: "danger",
        titleText: I18n.text('developer-docs-shared-components.codeSample.errorTitle'),
        style: {
          overflow: 'scroll'
        },
        className: "m-bottom-8",
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.codeSample.errorExplainationPart1"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.codeSample.errorExplainationPart2"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: () => {
            resetFormState();
            this.setState({
              error: null
            });
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.codeSample.resetExample"
          })
        })]
      });
    }

    return this.props.children;
  }

}
ErrorBoundary.propType = {
  hasError: PropTypes.bool.isRequired,
  registerError: PropTypes.func.isRequired,
  resetFormState: PropTypes.func.isRequired
};